export const benefits_economizar = [
    {
        title: "E-commerce",
        image: "/assets/benefits/ecommerce.gif",
        category: "Economizar",
        url: "ecommerce",
    },
    {
        title: "Lojas Físicas",
        image: "/assets/benefits/lojas.gif",
        category: "Economizar",
        url: "local",
    },
    {
        title: "Cinema",
        image: "/assets/benefits/cinema.gif",
        category: "Economizar",
        url: "cinema",
    },
];
